export default "__VITE_ASSET__DOhYTGno__"